import { render, staticRenderFns } from "./InpatientTables.vue?vue&type=template&id=5b10cbea&scoped=true&"
import script from "./InpatientTables.vue?vue&type=script&lang=js&"
export * from "./InpatientTables.vue?vue&type=script&lang=js&"
import style0 from "./InpatientTables.vue?vue&type=style&index=0&id=5b10cbea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10cbea",
  null
  
)

export default component.exports